import {t} from "i18next";
import * as Yup from "yup";

export interface MDXEditorForm {
  title: {
    en: string;
    ru: string;
    kk: string;
  };
  content: {
    en: string;
    ru: string;
    kk: string;
  };
  excerpt: {
    en: string;
    ru: string;
    kk: string;
  };
  tags: string[];
  defaultLanguage: string;
  availableLanguages: string[];
  publishedTime: Date | null;
  thumbnail: {
    id: string | number | null;
    url: string;
  };
}

export const initialValues: MDXEditorForm = {
  title: {
    en: "",
    ru: "",
    kk: ""
  },
  content: {
    en: "",
    ru: "",
    kk: ""
  },
  excerpt: {
    en: "",
    ru: "",
    kk: ""
  },
  tags: [],
  defaultLanguage: "ru",
  availableLanguages: ["en", "ru", "kk"],
  publishedTime: null,
  thumbnail: {
    id: null,
    url: ""
  }
}

export function ValidationSchema(
  currentDate: Date
) {
  return Yup.object({
    title: Yup.object({
      en: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('en'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      }),
      ru: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('ru'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      }),
      kk: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('kk'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      })
    }),
    content: Yup.object({
      en: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('en'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      }),
      ru: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('ru'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      }),
      kk: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('kk'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      })
    }),
    excerpt: Yup.object({
      en: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('en'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      }),
      ru: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('ru'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      }),
      kk: Yup.string().when('availableLanguages', {
        is: (availableLanguages: string[]) => availableLanguages && availableLanguages.includes('kk'),
        then: (schema) => schema.required(t("validation.required")),
        otherwise: (schema) => schema
      })
    }),
    tags: Yup.array().of(Yup.string()),
    defaultLanguage: Yup.string().required(t("validation.required")),
    availableLanguages: Yup.array().min(1, t("validation.at_least_one_language")),
    publishedTime: Yup.date()
      .typeError(t("validation.requiredDateAndTime"))
      .min(currentDate, t("validation.published_time"))
  })
}
